import axios, { AxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getCorrectBearerJwtForUrl } from 'components/accessControl/getCorrectBearerJwtForUrl';

// FYI: We require the baseURL parameter from AxiosRequestConfig since often multiple routes for a domain exist in the same route namespace.
// This also removes the need for a config object in the most common usage scenario.
export const APIFactory = (baseURL: string, config: Omit<AxiosRequestConfig, 'baseURL'> = {}) => {
  //FYI: every request should pass along an auth header
  const api = axios.create({
    ...config,
    baseURL,
  });
  // FYI: every request also sends along a spruce-request-id
  // This is so that the API can internally track the header/initiating request across its many internal requests
  api.interceptors.request.use((requestConfig) => {
    requestConfig.headers.set(
      'Authorization',
      `Bearer ${getCorrectBearerJwtForUrl(requestConfig.url ?? '')}`,
    );
    requestConfig.headers.set('spruce-request-id', uuidv4());

    if (config.headers) {
      Object.entries(config.headers).forEach(([key, value]) => {
        requestConfig.headers.set(key, value as string);
      });
    }

    return requestConfig;
  });
  return api;
};
